import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ThemeSwitcher from '@components/ThemeSwitcher';
import Cursor from '@components/cursor/Cursor';
import LoginAnimation from '@components/loadingViews/LoginAnimation';
import { useAppDispatch } from '@core/hooks/appHooks';
import { useDelayUnmount } from '@core/hooks/useDelayUnmount';
import { RoutingPaths, RoutingViews } from '@core/services/routingService';
import { setUser } from '@core/store/userSlice/userSlice';
import MotionButton from '@motion/Button';
import { useAuth } from '@providers/authProvider';
import { Button } from '@shadCN/ui/button';

import RegisterCard from './RegisterCard';
import SignInCard from './SignInCard';
import SignInError from './SignInError';

interface LoginProps {}

const Login: React.FC<LoginProps> = ({}) => {
  const CSSBlock = 'login';
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { signIn, MOCK_EMAIL, MOCK_PASSWORD } = useAuth();
  const [isVisible, setIsVisible] = useState(false);

  const [inputEmail, setInputEmail] = useState(MOCK_EMAIL);
  const [inputPassword, setInputPassword] = useState(MOCK_PASSWORD);
  const [error, setError] = useState<string>();

  const onSubmit = () => {
    setIsLoading(true);
    setTimeout(() => {
      signIn(inputEmail, inputPassword).then(res => {
        if (res) {
          dispatch(setUser(res));
          navigate(RoutingPaths[RoutingViews.HOME], { replace: true });
        } else {
          setError('Invalid email or password');
          setIsLoading(false);
        }
      });
    }, 2000);
  };

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [isGlobalLoadingMounted, setIsGlobalLoadingMounted] = useState(false);
  const shouldRenderGlobalLoading = useDelayUnmount(
    isGlobalLoadingMounted,
    3000
  );
  useEffect(() => {
    setIsGlobalLoadingMounted(isLoading);
  }, [isLoading]);

  return (
    <>
      <LoginAnimation loading={shouldRenderGlobalLoading} />
      {/* <LoginAnimation loading={true} /> */}
      <Cursor />
      <div
        className={`${CSSBlock}__wrapper ${
          !isVisible ? `${CSSBlock}--hide` : ''
        } ${error ? `${CSSBlock}--error` : ''} `}>
        <div className={`${CSSBlock}__content-position`}>
          <span className={`${CSSBlock}__sign-in`}>
            <SignInCard
              isLoading={isLoading}
              inputEmail={inputEmail}
              setInputEmail={setInputEmail}
              inputPassword={inputPassword}
              setInputPassword={setInputPassword}
              onSubmit={onSubmit}
            />
            <SignInError error={error} />
          </span>
        </div>
        <span className={`${CSSBlock}__submit-button`}>
          <MotionButton variant={'outline'} onClick={() => onSubmit()}>
            Sign In
          </MotionButton>
        </span>
      </div>
      {/* <ThemeSwitcher /> */}
    </>
  );
};

export default Login;
